import { cn } from "@babybjorn/ui";
import type { TCountryCode } from "countries-list";
import type { FC } from "react";
import * as s from "./Flag.module.scss";

export const isValidFlag = (countryCode: unknown): countryCode is FlagType => {
	return (
		typeof countryCode === "string" &&
		flagTypes.includes(countryCode as FlagType)
	);
};

export const getFlag = (
	allowedCountries: [TCountryCode, ...TCountryCode[]],
	countryCode?: TCountryCode,
): FlagType => {
	if (isValidFlag(countryCode)) {
		return countryCode;
	}
	if (allowedCountries.length === 1 && isValidFlag(allowedCountries[0])) {
		return allowedCountries[0];
	}

	return "GLOBAL";
};

const flagTypes = [
	"AE",
	"AT",
	"AU",
	"BE",
	"BG",
	"CA",
	"CH",
	"CN",
	"CY",
	"CZ",
	"DE",
	"DK",
	"EE",
	"ES",
	"FI",
	"FR",
	"GB",
	"GR",
	"HK",
	"HR",
	"HU",
	"ID",
	"IE",
	"IL",
	"IT",
	"JP",
	"KR",
	"KW",
	"KZ",
	"LB",
	"LT",
	"LU",
	"LV",
	"MN",
	"MO",
	"MY",
	"NL",
	"NO",
	"NZ",
	"PH",
	"PL",
	"PT",
	"RO",
	"RS",
	"RU",
	"SE",
	"SG",
	"SI",
	"SK",
	"TH",
	"TR",
	"TW",
	"UA",
	"US",
	"VN",
	"ZA",
	"GLOBAL",
] as const;

export type FlagType = (typeof flagTypes)[number];

const Flag: FC<{
	ariaLabel: string;
	className?: string;
	flagOverride?: FlagType;
	width?: number | "none";
	height?: number | "none";
}> = ({ flagOverride, width = 22, className, height = 16 }) => {
	return (
		<img
			src={`/flags_png/${flagOverride?.toLowerCase()}.png`}
			alt="Icon for selected country"
			className={cn(s.icon, className)}
			style={{
				width: width === "none" ? "none" : width / 16 + "rem",
				height: height === "none" ? "none" : height / 16 + "rem",
			}}
		/>
	);
};

export default Flag;
